<template>
  <search-group title="" @search="findData" @clear="clearValue">
    <Row :gutter="24">
      <Col span="4">
        <Select placeholder="是否显示" v-model="searchData.status">
          <Option value="">请选择</Option>
          <Option  v-for="item in conditionList" :value="item.value" :key="'keyA'+item.value">{{item.text}}</Option>
          <!--<option value=""></option>-->
        </Select>
      </Col>
      <Col span="6">
        <Input placeholder="按项目名称搜索" v-model="searchData.projectName" @keyup.enter.native="findData"></Input>
      </Col>
    </Row>
  </search-group>
</template>
<script>
  // import SearchGroup from 'components/SearchGroup/index';
  import {projectConfigcondition} from "../../../../api/projectConfig";

  export default {
    name: "SearchList",
    components: {
      // SearchGroup
    },
    props: {
    },
    data() {
      return {
        conditionList:[],  //{text:'禁止',value:0},{text:'显示',value:1}
        searchData: {
          page:1,
          limit:10,
          projectName:'',
          status:''
        },
      }
    },
    methods:{
      findData(){
        this.$emit('findData', this.searchData);
      },
      clearValue(){
        this.searchData={
          page:1,
          limit:10,
          projectName:'',
          status:''
        }
      },

    },
    created(){
      projectConfigcondition().then(res=>{
        res.data&& (this.conditionList=res.data.projectConfigStatus)
      }).catch(error=>{})
    }

  }
</script>

<style scoped>

</style>
